import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { OptionSelect } from '../../../../shared/components/search-select/search-select';
import { Expense } from '../../../../core/models/expense.interface';
import {
  ConsumableAsset,
  ConsumableAssetDTO,
} from '../../../../core/models/consumableasset.interface';
import { HttpErrorResponse } from '@angular/common/http';
import { FormUtils } from '../../../../shared/utils';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { ConsumableassetService } from '../../../../core/services/consumableasset/consumableasset-service';
import { LoadingService } from '../../../../core/services/loading/loading';
import { Subject, takeUntil } from 'rxjs';
import { MatOptionModule } from '@angular/material/core';
import { unityOptions } from './comsumableasset.definition';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-consumableasset-form',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatIcon,
    MatIconModule,
    FormsModule,
    MatOptionModule,
    MatSelectModule,
  ],
  templateUrl: './consumableasset-form.html',
  styleUrl: './consumableasset-form.scss',
})
export class ConsumableassetForm {
  consumableasset: string | null = null;
  errorMsg: string[] | null = null;
  consumableassetSelected: ConsumableAsset | null = null;
  expenseSelected: OptionSelect[] = [];
  listExpenses: Expense[] = [];
  selectExpense: OptionSelect | null = null;
  expenseSeleccionado: Expense | null = null;
  unityOptions = unityOptions;
  private formBuilder = inject(FormBuilder);
  protected _onDestroy = new Subject<void>();

  constructor(
    private dialogRef: MatDialogRef<ConsumableassetForm>,
    private toastr: ToastrService,
    private consumableAssetService: ConsumableassetService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.fetchConsumableAsset();
    this.consumableAssetService.asyncErrorValidation$.subscribe((error) => {
      if (error) {
        this.errorMsg = FormUtils.parseErrorMsgs(error);
      }
    });

    this.consumableassetForm
      .get('unity')
      ?.valueChanges.pipe(takeUntil(this._onDestroy))
      .subscribe((value) => {
        const packageControl = this.consumableassetForm.get('package');
        if (!packageControl) return;

        if (value === 'und') {
          packageControl.setValue(1);
          packageControl.disable();
        } else {
          packageControl.enable();
        }
      });

    if (this.consumableassetForm.get('unity')?.value === 'und') {
      this.consumableassetForm.get('package')?.setValue(1);
      this.consumableassetForm.get('package')?.disable();
    }
  }

  private fetchConsumableAsset() {
    this.consumableAssetService.selectedConsumableAsset$.subscribe((consumableAsset) => {
      if (consumableAsset) {
        this.consumableasset = String(consumableAsset.id);
        this.consumableassetSelected = consumableAsset;
        this.consumableassetForm.patchValue({
          ...this.consumableassetSelected,
        });
      }
    });
  }

  consumableassetForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(150)]],
    description: ['', []],
    unity: ['', [Validators.required, Validators.maxLength(150)]],
    value: [0, [Validators.required]],
    package: [0, [Validators.required]],
  });

  closeDialog() {
    this.dialogRef.close();
  }

  saveconsumableAsset() {
    const payload = this.consumableassetForm.value as ConsumableAssetDTO;
    if (this.consumableassetForm.status === 'VALID' && !this.consumableasset) {
      this.loadingService.show(true);
      this.consumableAssetService.createConsumableAsset(payload).subscribe({
        next: (consumableAsset) => {
          this.loadingService.show(false);
          const msg = `El activo consumible ${consumableAsset.name} fue CREADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    } else if (this.consumableassetForm.status === 'VALID' && this.consumableasset) {
      this.loadingService.show(true);
      const id = Number(this.consumableasset);
      this.consumableAssetService.UpdateConsumableAsset(id, { ...payload, id: id }).subscribe({
        next: (consumableAsset) => {
          this.loadingService.show(false);
          const msg = `El activo consumible ${consumableAsset.name} fue EDITADO correctamente!`;
          this.toastr.success(msg, 'Exitoso!', {
            progressBar: true,
            timeOut: 5000,
          });
          this.dialogRef.close();
        },
        error: ({}: HttpErrorResponse) => {
          if (this.errorMsg) {
            this.loadingService.show(false);
            this.toastr.error('Error: ' + this.errorMsg, undefined, {
              progressBar: true,
              timeOut: 5000,
            });
          }
        },
      });
    }
  }
}
